import { render, staticRenderFns } from "./EquipmentRelationships.vue?vue&type=template&id=0b2aee30&scoped=true&"
import script from "./EquipmentRelationships.vue?vue&type=script&lang=js&"
export * from "./EquipmentRelationships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2aee30",
  null
  
)

export default component.exports